var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('fullscreen-countdown',{attrs:{"time":5,"enabled":_vm.shouldDoTimer},on:{"doneTimer":function($event){return _vm.onDoneTimer()}}}),_c('question-data-component',{directives:[{name:"show",rawName:"v-show",value:(_vm.showQuestion),expression:"showQuestion"}],attrs:{"contestData":_vm.contestData,"type":"contest"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }